import React from 'react';

import Link from '../../library/link/link';
import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import GroupAffiliationPromotionIdMeButton from '../group-affiliation-promotion-id-me-button/group-affiliation-promotion-id-me-button';
import GroupAffiliationPromotionTitle from '../group-affiliation-promotion-title/group-affiliation-promotion-title';

import { useGroupAffiliation } from '../../shared/hooks/hooks';

import './group-affiliation-promotion.scss';

interface GroupAffiliationPromotionProps {
  className?: string;
  onRefresh?: () => void;
  showAppliedDiscount?: boolean;
  showTitle?: boolean;
}

function GroupAffiliationPromotion(props: GroupAffiliationPromotionProps) {
  const { className, onRefresh, showAppliedDiscount, showTitle } = props;
  const {
    groupAffiliationPromotion,
    isAppliedPromotion,
    openVerificationWindow,
    promotion
  } = useGroupAffiliation({
    onRefresh
  });

  const {
    verificationDiscountAppliedMessage,
    verificationSuccessMessage,
    verificationSuccessTooltipMessage
  } = groupAffiliationPromotion || {};

  return (
    <div className={className}>
      <GroupAffiliationPromotionTitle
        showTitle={showTitle}
        styleName="title"
        title="Deals"
      />
      <div
        className="group-affiliation-promotion__content-no-discount"
        styleName={showAppliedDiscount ? 'content' : 'content-no-discount'}
      >
        <div
          styleName={
            showAppliedDiscount ? 'description' : 'description-no-discount'
          }
        >
          <Typography
            className="group-affiliation-promotion__description-text"
            size="small"
            styleName="description-text"
            tag="div"
          >
            {promotion?.description}
          </Typography>
          {promotion?.detailsUrl && (
            <Link
              className="group-affiliation-promotion__link"
              target="_blank"
              to={promotion.detailsUrl}
            >
              learn more about this discount
            </Link>
          )}
        </div>

        {isAppliedPromotion && showAppliedDiscount && (
          <div styleName="applied-discount">
            <Typography
              size="small"
              styleName="applied-discount-message"
              tag="div"
            >
              {verificationSuccessMessage}
              <Tooltip
                content={verificationSuccessTooltipMessage}
                styleName="applied-tooltip"
              />
            </Typography>

            <span styleName="discount-price">
              {verificationDiscountAppliedMessage}
            </span>
          </div>
        )}

        {isAppliedPromotion && !showAppliedDiscount && (
          <div styleName="applied-promotion-message">
            {verificationSuccessMessage}
            <Tooltip
              content={verificationSuccessTooltipMessage}
              styleName="applied-tooltip"
            />
          </div>
        )}

        <GroupAffiliationPromotionIdMeButton
          isAppliedPromotion={isAppliedPromotion}
          openVerificationWindow={openVerificationWindow}
          styleName="discount-price"
        />
      </div>
    </div>
  );
}

export default GroupAffiliationPromotion;
